module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-dark-screens-4-3.4a33b5d5.png";